module.exports = "/assets/c167953704250ec10075bd3cfee940b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cars/assets/logos/ZR.png
// module id = 769
// module chunks = 0